export default __webpack_public_path__ + "static/media/pin-kwong-fuk-bridge.d590c60a.png";